import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { CardGridWrapper } from "../../../components/Card/CardGridWrapper";
import { StoreCard } from "../../../components/Card/StoreCard";
import { CARD_GRID_COLUMN_GAP, CARD_WIDTH } from "../../../config/layoutConfig";
import { AppContext } from "../../../context";
import { openkit } from "../../../library/database";
import NoResults from "../NoResults";

const CardGridContainer = styled.div`
  width: ${(props) => props.innerWidth};
  /* width: 85%; */
  margin: 0 auto;
  /* display: flex; */
  /* justify-content: center; */
  /* z-index: -200; */
`;

function SuggestionsGrid({ type, villages, layoutDim }) {
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsInnerWidth, setSuggestionsInnerWidth] = useState(null);

  const info = useContext(AppContext);

  useEffect(() => {
    // get random suggestions of associates
    async function dbGetRandomStoresFn() {
      const query = { type, villages, items: 6 };
      try {
        const randomStores = await openkit.custom.execute(
          "post",
          "global_suggestions",
          null,
          {
            query,
          }
        );

        setSuggestions(randomStores);
      } catch (error) {
        console.log(error);
      }
    }
    if (type || villages.length) dbGetRandomStoresFn();
  }, [villages, type]);

  useEffect(() => {
    // calculate innerWidth

    setSuggestionsInnerWidth(
      suggestions.length < layoutDim.cardsPerRow
        ? suggestions.length * (CARD_WIDTH + CARD_GRID_COLUMN_GAP) +
            CARD_GRID_COLUMN_GAP +
            "px"
        : layoutDim.cardsPerRow * (CARD_WIDTH + CARD_GRID_COLUMN_GAP) +
            CARD_GRID_COLUMN_GAP +
            "px"
    );
  }, [suggestions]);

  return (
    suggestions.length > 0 &&
    (type || villages.length > 0) && (
      <div className="ahp-main-filter-suggestions">
        <h1
          style={{
            margin: "30px auto",
            textAlign: "center",
          }}
        >
          {info.t("suggestionText")}
        </h1>{" "}
        <CardGridContainer innerWidth={suggestionsInnerWidth}>
          <CardGridWrapper innerWidth={suggestionsInnerWidth}>
            {suggestions?.length > 0 ? (
              suggestions?.map((store, index) => (
                <StoreCard store={store} key={index} />
              ))
            ) : (
              <NoResults />
            )}
          </CardGridWrapper>
        </CardGridContainer>
      </div>
    )
  );
}

export default SuggestionsGrid;
